import script from "./AccountCreation.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountCreation.vue?vue&type=script&setup=true&lang=js"

import "./AccountCreation.vue?vue&type=style&index=0&id=124ed95a&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124ed95a"]])

export default __exports__